import React, { useEffect, useState } from "react";
import { useAuth } from "../context/contextAuth";
import { useProfile } from "../context/contextProfile";
import { useThemeMode } from "../context/contextTheme";
import { useNavigate, Link } from "react-router-dom";
import Loader3 from "../components/loaders/Loader-3";
import LogoImg from "../assets/img/logo/Save-Logo-Blue-2.png";

export default function MFA() {
  const { theme, mode } = useThemeMode();
  const { loadingAuth, getVerify, setSignIn } = useAuth();
  const { zoomLevel } = useProfile();

  const [seconds, setSeconds] = useState(60);
  const [timerActive, setTimerActive] = useState(true);
  const [error, setError] = useState(null);
  const [code, setCode] = useState(Array(6).fill(""));
  const navigate = useNavigate();

  useEffect(() => {
    if (!timerActive) return;
    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setTimerActive(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timerActive]);

  useEffect(() => {
    if (!timerActive && seconds === 0) {
      navigate("/");
    }
  }, [timerActive, seconds, navigate]);

  useEffect(() => {
    document.body.style.backgroundImage =
      "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.height = "100vh";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, [mode, theme.background]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newCode = [...code];
    newCode[index] = value.substring(value.length - 1);
    setCode(newCode);

    if (value !== "" && index < code.length - 1) {
      document.getElementById(`code-input-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && code[index] === "" && index > 0) {
      document.getElementById(`code-input-${index - 1}`)?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await getVerify(code.join(""));
      if (response.error) {
        setError(response.error);
      } else {
        setSignIn(true);
        navigate("/dashboard");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="position-fixed top-50 start-50 translate-middle w-100 d-flex justify-content-center">
      {loadingAuth ? (
        <Loader3 />
      ) : (
        <div
          className="bg-white rounded-4 shadow-lg p-5"
          style={{
            maxWidth: 420,
            width: "95%",
            transform: `scale(${zoomLevel})`
          }}
        >
          {/* Logo */}
          <div className="text-center mb-4">
            <img src={LogoImg} alt="Logo" height={50} />
          </div>

          {/* Header */}
          <div className="text-center mb-4">
            <h4 className="fw-bold text-dark">
              Verify Code
            </h4>
            <p className="text-secondary small">
              Enter the 6-digit code sent to your email.
            </p>
          </div>

          {/* Timer */}
          <div className="d-flex justify-content-center mb-4">
            {timerActive ? (
              <div
                className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
                style={{
                  width: 80,
                  height: 80,
                  backgroundColor: "#f1f5f9",
                  border: "4px solid #e2e8f0",
                  fontSize: "1.8rem",
                  color: "#0ea5e9"
                }}
              >
                {seconds}
              </div>
            ) : (
              <div className="text-danger fw-semibold">
                Code Expired
              </div>
            )}
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-between mb-4">
              {code.map((digit, index) => (
                <input
                  key={index}
                  id={`code-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  className="form-control text-center fw-semibold"
                  style={{
                    width: 45,
                    height: 55,
                    fontSize: "1.4rem",
                    borderRadius: 8
                  }}
                />
              ))}
            </div>

            {error && (
              <div className="alert alert-danger small text-center">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="btn w-100 fw-bold rounded-3"
              style={{
                backgroundColor: "#0ea5e9",
                color: "#fff",
                padding: "12px"
              }}
            >
              Verify
            </button>

            <div className="text-center mt-4 small">
              <Link
                to="/signin"
                className="fw-bold text-decoration-none"
                style={{ color: "#0ea5e9" }}
              >
                Back to Sign In
              </Link>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}